
import sharedStyles from 'styles/css/SharedStyles.module.scss';
// import styles from 'styles/css/Main.module.scss';
// import drawerStyles from 'styles/css/Drawer.module.scss';
// import actionStyles from 'styles/css/ActionStyles.module.scss';
// import Logo from 'styles/images/logo/logo512.png';

import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';
import formStyles from 'styles/css/FormStyles.module.scss';
import ruleStyles from 'styles/css/RuleStyles.module.scss';
import CeoImage from 'styles/images/aboutus/ceo.jpg';
import { Link } from 'react-router-dom';
import { WEBSITE } from 'apis';

const Certificates = () => {

    return (
        
        <div className={sharedStyles.container} id={ruleStyles['rules-page']}>

            <div className={[sharedStyles['container-padding'], sharedStyles['pb-[64px]']].join(' ')}>
                <ShortHeaderWithBackBtn />
                
                <div className={formStyles['text-right']}>
                    <a href={`${WEBSITE}images/certificates/dioploma.jpg`} target="_blank" style={{textDecoration: 'none'}} className={ruleStyles['font-weight-800']}>دانش نامه</a>
                    <br />
                    <br />
                    <a href={`${WEBSITE}images/certificates/permanent_license.jpg`} style={{textDecoration: 'none'}} className={ruleStyles['font-weight-800']}>پروانه دائم پزشکی</a>
                    <br />
                    <br />
                    <a href={`${WEBSITE}images/certificates/medical_practice_license.jpg`} style={{textDecoration: 'none'}} className={ruleStyles['font-weight-800']}>پروانه مطب</a>
                    <br />
                    <br />
                    <a href={`${WEBSITE}images/certificates/business_license_2.jpg`} style={{textDecoration: 'none'}} className={ruleStyles['font-weight-800']}>پروانه کسب Dr20</a>
                    <br />
                    <br />
                    <a href={`${WEBSITE}images/certificates/tourism_service_certificates.jpg`} style={{textDecoration: 'none'}} className={ruleStyles['font-weight-800']}>گواهینامه خدمات گردشگری</a>
                    
                </div>

            </div>
                
        </div>

    );
}

export default Certificates;